import EyeSalesAnalytics from '@assets/icons/eye-sales-analytics.svg'
import { Icon } from './Icon'

export const EyeSalesAnalyticsIcon = Icon(EyeSalesAnalytics)
